import styled from '@emotion/styled';

export const Divider = styled('div')<{ margin?: number }>((p) => ({
  marginTop: p.theme.spacing(p.margin ?? 0.5),
  marginBottom: p.theme.spacing(p.margin ?? 0.5),
  borderBottom: p.theme.custom.border.standard,
  width: '100%'
}));
